import React from "react";
import { SolutionVariableTable } from "../../powerFlow/solutionVariables";
import { inputHeader, inputCell, outputHeader, outputCell } from "./tableStyles";

interface Props {
  table?: SolutionVariableTable;
  /**
   * The editor for the ranged rule that declares this variable class and its
   * bounds, e.g. "def charge_bounds(b: battery, t: timestep): 0 <= P_charge(b, t) <= b.max_charge".
   */
  ruleEditor?: React.ReactNode;
}

/**
 * Renders a single class of decision variables (e.g. P_gen) as a table:
 * its index columns (gen_id, timestamp, ...) plus value and status. Grouping
 * into classes is done by the tree, so there's no tab bar here. Index columns
 * are the inputs; value and status are the solver's output (tinted monospace).
 * The rule that declares the class sits above them, editable.
 */
const VariableTableView: React.FC<Props> = ({ table, ruleEditor }) => {
  if (!table || table.rows.length === 0) {
    return (
      <>
        {ruleEditor}
        <div style={{ padding: "12px", color: "#666", fontStyle: "italic" }}>
          No variables available
        </div>
      </>
    );
  }

  return (
    <>
      {ruleEditor}
      <table
      style={{ borderCollapse: "separate", borderSpacing: 0, width: "100%" }}
    >
      <thead>
          <tr>
            {table.columns.map((column) => (
              <th key={column} style={inputHeader}>
                {column}
              </th>
            ))}
            <th key="__value" style={{ ...outputHeader, textAlign: "right" }}>
              value
            </th>
            <th key="__status" style={outputHeader}>
              status
            </th>
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row) => (
            <tr key={row.name}>
              {table.columns.map((column) => (
                <td key={column} style={inputCell}>
                  {String(row.indices[column] ?? "")}
                </td>
              ))}
              <td style={{ ...outputCell, textAlign: "right" }}>
                {row.value !== undefined ? row.value.toFixed(3) : "—"}
              </td>
              <td style={outputCell}>{row.status || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default VariableTableView;
